export default {
  contacts: null,
  payments: null,
  tariff: null,
  accountData: null,
  billingData: null,
  smsHistory: null
};
